/**
 * Convert date object's time to UTC ics's format
 * @param {Date} date
 * @returns {String}
 */
export const convertDateToIcsFileFormat = date => {
  return (
    `${date.getUTCFullYear()}${createFullDateValue(date.getUTCMonth() + 1)}${createFullDateValue(
      date.getUTCDate()
    )}T` +
    `${createFullDateValue(date.getUTCHours())}${createFullDateValue(date.getUTCMinutes())}00`
  )
}

export const createFullDateValue = value => {
  return parseInt(value) >= 10 ? value : '0' + value
}
